import Cookies from 'js-cookie';
import { getUserIsLoggedIn } from '../../../Utils/helper';

export const showNewLogin = () => {
  // return getWebUserType() === "B";
  return true;
};
export const hideLoginPageFromRoute = (router) => {
  let params = new URLSearchParams(window.location.search);
  const fromAddress = JSON.parse(params.get('fromAddress'));
  const fromLogin = Object.keys(router.components).includes('/login');
  const onAddress =
    router.asPath.includes('changeaddress') ||
    router.asPath.includes('/address/');
  const skip = Cookies.get(fromSkip)
    ? JSON.parse(Cookies.get(fromSkip))
    : false;
  if (fromLogin && fromAddress && (getUserIsLoggedIn() || skip) && onAddress) {
    router.beforePopState(() => {
      router.back();
      return true;
    });
  }
};

export const removeCountryCode = (mobileNumber) => {
  if (mobileNumber.charAt(0) == '+') {
    mobileNumber = mobileNumber.replace(/[^a-zA-Z0-9+]/g, '').substr(3);
  } else if (mobileNumber.charAt(0) == '0') {
    mobileNumber = mobileNumber.replace(/[^a-zA-Z0-9+]/g, '').substr(1);
  }

  if (mobileNumber.length > 10) return mobileNumber.substr(0, 10);

  return mobileNumber;
};
export const fromSkip = 'fromSkip';
